import React from 'react';
import PaymentsTableRow from './PaymentsTableRow';

const PaymentsTable = ({ payments }) => {
    const paymentsTableRows = [];
    payments.forEach(payment => {
        paymentsTableRows.push(<PaymentsTableRow {...payment} />);
    });
    return (
        <div className="card card-transparent">
            <div className="card-title border-0">
                <h5 className="text-muted">Pagamentos</h5>
            </div>
            <table className="table">
                <thead>
                    <tr>
                        <th>Cartão Truncado</th>
                        <th>Parcelas</th>
                        <th className="text-right">Total</th>
                    </tr>
                </thead>
                <tbody>{paymentsTableRows}</tbody>
            </table>
        </div>
    );
}

export default PaymentsTable;



// WEBPACK FOOTER //
// ./src/components/Pages/Receipt/PaymentsTable.js